var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWomanWorking2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 905.13 707.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#02263c;}.cls-2{fill:#ffb999;}.cls-3{fill:#eddfdf;}.cls-4{fill:#fc8c60;}.cls-5{fill:#277ba0;}.cls-6{fill:#74cff7;}.cls-7{fill:#ea5347;}.cls-8{fill:#e2ecff;}.cls-10,.cls-9{fill:#c5d5ed;}.cls-9{opacity:0.38;}.cls-11{fill:#99b0d1;}.cls-12{fill:#b7959a;}.cls-13,.cls-25,.cls-26{fill:#ceb6b9;}.cls-14{fill:#efd8db;}.cls-15{fill:#f6c375;}.cls-16,.cls-27{fill:#f2a43d;}.cls-16{opacity:0.49;}.cls-17{fill:#e29233;}.cls-18{fill:#78ad04;}.cls-19{fill:#83ce00;}.cls-20{fill:#ade701;}.cls-21{fill:#fff;}.cls-22{fill:#fe6f5d;}.cls-23{fill:#4092c1;}.cls-24{fill:#f9eded;}.cls-25{opacity:0.4;}.cls-26{opacity:0.45;}.cls-28{fill:#e23c30;}.cls-29{fill:#ea754b;}.cls-30{fill:#021b28;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M385.69,51.85c0-.63.05-1,.1-1.51s.09-.91.15-1.36c.12-.9.27-1.78.44-2.65q.51-2.61,1.26-5.13a54.59,54.59,0,0,1,4-9.69,52.34,52.34,0,0,1,12.95-16,59.22,59.22,0,0,1,8.39-5.73,64.62,64.62,0,0,1,9.14-4.15,83.37,83.37,0,0,1,19.28-4.45,82.56,82.56,0,0,0-18.5,6.29,61.62,61.62,0,0,0-8.33,4.86,55.79,55.79,0,0,0-7.29,6.13A47.56,47.56,0,0,0,397,34.05a48.31,48.31,0,0,0-2.61,8.83c-.28,1.51-.49,3-.63,4.52-.06.75-.11,1.5-.13,2.24,0,.37,0,.74,0,1.09s0,.76,0,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M384.18,51.1c-.14-.45-.21-.76-.29-1.08s-.15-.64-.21-1c-.13-.62-.25-1.24-.34-1.85-.21-1.21-.32-2.42-.45-3.62s-.15-2.4-.18-3.6,0-2.38.05-3.57a52,52,0,0,1,2.46-13.81,49.44,49.44,0,0,1,5.86-12.36,52,52,0,0,1,4-5.42,28.77,28.77,0,0,1,2.23-2.46L399.57,0l-1.74,2.8a26.38,26.38,0,0,0-1.64,2.81,50,50,0,0,0-2.66,5.89,45.75,45.75,0,0,0-2.93,12.26A45.17,45.17,0,0,0,391,36c.14,1,.4,2,.58,3s.51,1.94.78,2.89.6,1.89,1,2.78c.17.46.36.89.55,1.31a5.82,5.82,0,0,0,.28.61,3,3,0,0,0,.25.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M386,56.58c-.34-.33-.54-.57-.76-.82s-.44-.5-.63-.74c-.4-.49-.8-1-1.16-1.48-.75-1-1.41-2-2.08-3s-1.26-2-1.84-3.1-1.13-2.09-1.61-3.18a51.57,51.57,0,0,1-4.24-13.38,49.86,49.86,0,0,1-.57-13.66,52.1,52.1,0,0,1,1-6.64A27.7,27.7,0,0,1,375,7.36l.91-3.17-.24,3.28a27.44,27.44,0,0,0-.14,3.26,49.32,49.32,0,0,0,.38,6.45A45.56,45.56,0,0,0,379,29.39a45.08,45.08,0,0,0,6.05,10.66c.59.82,1.27,1.57,1.89,2.35s1.35,1.49,2,2.2,1.41,1.39,2.15,2c.36.33.73.62,1.09.91.18.15.36.29.53.41a4.38,4.38,0,0,0,.44.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M356.62,105.32a58.57,58.57,0,0,0-19.14,45.88c4.54-9.85,11.24-19.08,20.49-24.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M361.32,118.5c-12.66,11.18-20,28.74-19.14,45.88,4.55-9.86,11.25-19.08,20.5-24.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M376,199.12a58.6,58.6,0,0,1-42.27,26.17c9-6,17.05-14.12,20.6-24.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M379,226.6c-9,14.27-25.21,24.29-42.27,26.18,9-6.06,17.06-14.13,20.6-24.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M645.55,328.47c8.55-1.47,18.35-3.1,23.66-3.82l5.09,26.14-57-8.75h0A57.06,57.06,0,0,1,645.55,328.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M643.81,326.92c-1.1,6.84-5.11,12.06-11.68,14.26-26.79,9-60.55,4.82-85.15-9.11a97.54,97.54,0,0,1-16.33-11.62,102.39,102.39,0,0,1-32.57-54.65l11.28-57.88c.57.35,1.12.71,1.66,1.09,2.2,1.5,5.23,3.2,7.1,5.07l-1,0c3.67,3.64,7.74,7.89,10.33,12.47a99.44,99.44,0,0,1,7.92,18.59c4.67,14.56,7.4,29.87,14.33,43.5C566.45,321.6,608.88,338.84,643.81,326.92Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "662.25 628.33 674.58 661.08 703.95 654.59 678.06 625.51"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "662.25 628.33 666.74 640.26 688.62 637.37 678.06 625.51"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M575.85,411.29l43.8,14.34a45,45,0,0,1,28.15,27h0a521.59,521.59,0,0,1,25.52,95.12L688,634.92l-24.85,1.5L606.34,510.31"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M595.44,462.14a1,1,0,0,1-.92-.61l-1.38-3.21a1,1,0,1,1,1.83-.79l1.39,3.21a1,1,0,0,1-.52,1.31A1,1,0,0,1,595.44,462.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M662.45,617.16a1,1,0,0,1-.92-.61l-2.8-6.45a1,1,0,0,1,.53-1.32,1,1,0,0,1,1.31.52l2.79,6.46a1,1,0,0,1-.52,1.32A1.09,1.09,0,0,1,662.45,617.16Zm-5.59-12.92a1,1,0,0,1-.92-.6l-2.79-6.46a1,1,0,1,1,1.84-.8l2.79,6.46a1,1,0,0,1-.52,1.32A1.14,1.14,0,0,1,656.86,604.24Zm-5.58-12.92a1,1,0,0,1-.92-.6l-2.79-6.46a1,1,0,1,1,1.83-.8l2.8,6.46a1,1,0,0,1-.53,1.32A1,1,0,0,1,651.28,591.32Zm-5.59-12.92a1,1,0,0,1-.91-.6l-2.8-6.46a1,1,0,1,1,1.84-.79l2.79,6.46a1,1,0,0,1-.52,1.31A.92.92,0,0,1,645.69,578.4Zm-5.58-12.92a1,1,0,0,1-.92-.6l-2.79-6.46a1,1,0,0,1,1.84-.79l2.79,6.46a1,1,0,0,1-.52,1.31A1,1,0,0,1,640.11,565.48Zm-5.58-12.91a1,1,0,0,1-.92-.61l-2.79-6.46a1,1,0,1,1,1.83-.79l2.79,6.46a1,1,0,0,1-.52,1.31A.92.92,0,0,1,634.53,552.57Zm-5.59-12.92A1,1,0,0,1,628,539l-2.79-6.46a1,1,0,0,1,1.84-.79l2.79,6.46a1,1,0,0,1-.52,1.31A.93.93,0,0,1,628.94,539.65Zm-5.58-12.92a1,1,0,0,1-.92-.6l-2.79-6.46a1,1,0,1,1,1.84-.8l2.79,6.46a1,1,0,0,1-.52,1.32A1.14,1.14,0,0,1,623.36,526.73Zm-5.58-12.92a1,1,0,0,1-.92-.6l-2.79-6.46a1,1,0,1,1,1.83-.8l2.79,6.46a1,1,0,0,1-.52,1.32A1.09,1.09,0,0,1,617.78,513.81Zm-5.59-12.92a1,1,0,0,1-.92-.6l-2.79-6.46a1,1,0,1,1,1.84-.79l2.79,6.45a1,1,0,0,1-.52,1.32A.92.92,0,0,1,612.19,500.89ZM606.61,488a1,1,0,0,1-.92-.6l-2.79-6.46a1,1,0,0,1,.52-1.31,1,1,0,0,1,1.32.52l2.79,6.46a1,1,0,0,1-.52,1.31A1,1,0,0,1,606.61,488ZM601,475.06a1,1,0,0,1-.92-.61L597.32,468a1,1,0,0,1,1.83-.79l2.79,6.46a1,1,0,0,1-.52,1.31A.92.92,0,0,1,601,475.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M666.62,626.83a1,1,0,0,1-.91-.6L664.32,623a1,1,0,1,1,1.83-.79l1.39,3.21a1,1,0,0,1-.52,1.32A1.1,1.1,0,0,1,666.62,626.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M664.42,667c-.16-6.31,0-13.35,4.31-17.92a4.38,4.38,0,0,1,2.76-1.55,5,5,0,0,1,3,1.19c2.34,1.64,4.57,3.54,7.26,4.5s6.07.74,7.94-1.42,1.66-5.74,3.35-8.18,4.72-3.17,7.48-2.74A17.32,17.32,0,0,1,708,644.5c10.44,7.86,17.76,20,29.77,25.17,4.94,2.13,10.43,2.92,15.18,5.47s8.79,7.77,7.47,13c-1.1,4.29-5.49,7-9.86,7.8-4.73.81-9.57-.18-14.27-1.17l-42.82-9"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 754.34,
    y: 336.38,
    width: 14.4,
    height: 12.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 736.13,
    y: 336.38,
    width: 14.4,
    height: 12.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 717.92,
    y: 336.38,
    width: 14.4,
    height: 12.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 699.71,
    y: 336.38,
    width: 14.4,
    height: 12.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 772.56,
    y: 336.38,
    width: 14.4,
    height: 12.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 790.77,
    y: 336.38,
    width: 14.4,
    height: 12.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 808.98,
    y: 336.38,
    width: 14.4,
    height: 12.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 849.94,
    y: 100.18,
    width: 35.01,
    height: 223.06
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 854.34,
    y: 100.18,
    width: 30.62,
    height: 223.06
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 858.11,
    y: 82.26,
    width: 35.01,
    height: 284.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 858.11,
    y: 341.33,
    width: 35.01,
    height: 25.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 657.36,
    y: 343.15,
    width: 183.53,
    height: 24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 639.85,
    y: 343.15,
    width: 183.53,
    height: 24
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-12",
    cx: 222.44,
    cy: 321.6,
    r: 13.84
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M224.2,279.34h-53a4.09,4.09,0,0,0-4.07,4.51l8.17,81a4.09,4.09,0,0,0,4.08,3.68H213.3a4.08,4.08,0,0,0,4.06-3.55l10.9-81A4.1,4.1,0,0,0,224.2,279.34Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-14",
    cx: 410.48,
    cy: 401.01,
    r: 144.37
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-15",
    points: "497.14 482.8 531.15 703.23 514.14 703.23 431.66 516.79"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-15",
    points: "323.62 481.17 289.61 701.6 306.61 701.6 389.1 515.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M323.62,481.17l-11,71.06h0a52.81,52.81,0,0,0,49,18.43l3.1-.5,24.34-55"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M301.24,701.76a.8.8,0,0,1-.3-.06.74.74,0,0,1-.39-1l7.65-18.1c2.49-5.9,4.83-12,6.94-18l11-31.44a306.56,306.56,0,0,1,19.7-44.55,306,306,0,0,0,21.8-50.85l2.69-8.26a.76.76,0,0,1,.94-.48.75.75,0,0,1,.48,1l-2.68,8.26a308.13,308.13,0,0,1-21.91,51.1,305.74,305.74,0,0,0-19.61,44.33l-11,31.44c-2.12,6.06-4.47,12.14-7,18.07l-7.65,18.09A.75.75,0,0,1,301.24,701.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M293.94,702.27h-.11a.76.76,0,0,1-.63-.86L296.34,681c1-6.35,2.26-12.75,3.69-19l7.38-32.48a305.86,305.86,0,0,0,6.94-48,307.38,307.38,0,0,1,8.59-54.93l2.12-8.42a.75.75,0,1,1,1.45.36L324.4,527a305,305,0,0,0-8.55,54.66,307.45,307.45,0,0,1-7,48.21l-7.38,32.48c-1.42,6.24-2.65,12.61-3.67,18.92l-3.14,20.39A.74.74,0,0,1,293.94,702.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M328.13,588.2a.73.73,0,0,1-.25,0,.76.76,0,0,1-.5-.68c-.83-20.17,7.93-74.88,8-75.43a.75.75,0,1,1,1.48.24c-.08.53-8.31,51.88-8.05,73.24,6.12-7,32.68-38.42,39.24-62.14a.75.75,0,1,1,1.44.4C362,550.86,329,587.59,328.69,588A.74.74,0,0,1,328.13,588.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M315.93,640.56a.71.71,0,0,1-.32-.07.73.73,0,0,1-.36-1,112.16,112.16,0,0,0,8.91-31.18.75.75,0,1,1,1.49.21,113.85,113.85,0,0,1-9,31.6A.76.76,0,0,1,315.93,640.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M518.81,703a.75.75,0,0,1-.69-.45l-7.65-18.1c-2.5-5.91-4.85-12-7-18.07l-11-31.43a305.8,305.8,0,0,0-19.6-44.34A306.35,306.35,0,0,1,451,539.52l-2.69-8.27a.75.75,0,0,1,.48-.94.76.76,0,0,1,.95.48l2.68,8.26A306,306,0,0,0,474.2,589.9a308.26,308.26,0,0,1,19.7,44.55l11,31.44c2.11,6,4.45,12.09,6.94,18L519.5,702a.76.76,0,0,1-.4,1A.71.71,0,0,1,518.81,703Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M526.1,703.51a.75.75,0,0,1-.74-.63l-3.13-20.4c-1-6.3-2.26-12.67-3.68-18.91l-7.37-32.48a307.8,307.8,0,0,1-7-48.21,307,307,0,0,0-8.55-54.67l-2.12-8.42a.75.75,0,0,1,1.46-.37l2.11,8.43a307.1,307.1,0,0,1,8.59,54.93,306.76,306.76,0,0,0,6.95,48L520,663.23c1.42,6.28,2.66,12.68,3.69,19l3.13,20.4a.73.73,0,0,1-.62.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M491.91,589.45a.77.77,0,0,1-.56-.25C491,588.84,458,552.1,450.53,525a.75.75,0,1,1,1.45-.41c6.56,23.73,33.12,55.13,39.23,62.14.27-21.35-8-72.7-8-73.23a.75.75,0,1,1,1.48-.24c.09.55,8.86,55.26,8,75.43a.76.76,0,0,1-.49.68A.78.78,0,0,1,491.91,589.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M504.12,641.81a.76.76,0,0,1-.68-.43,113.51,113.51,0,0,1-9-31.6.75.75,0,1,1,1.48-.21,112.18,112.18,0,0,0,8.92,31.17.76.76,0,0,1-.36,1A.77.77,0,0,1,504.12,641.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M497.14,482.8l10.33,67h0a115.9,115.9,0,0,1-54.7,10.37l-2-.11-19.14-43.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "897.29 701.01 860 701.01 789 375.79 826.29 375.79 897.29 701.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "833.55 409.04 796.26 409.04 789 375.79 826.29 375.79 833.55 409.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "164.44 701.01 201.73 701.01 272.73 375.79 235.44 375.79 164.44 701.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "229.09 404.87 266.12 404.87 272.73 375.79 235.44 375.79 229.09 404.87"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M96.39,283.09c-2.26,2.26-5.41,0-8.09,1.06-6.15,2.38-12.42,1.92-23.8-5.63-.52,4.66,1.26,9.21,3.34,13,6.84,12.33,17.74,20.18,29,20.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M99.61,282.6c-1.73,4.71-6.57,4.7-9.36,8.29C83.87,299.1,76,304,58.79,304.64c1.47,6.11,5.7,10.1,9.92,12.85a40.47,40.47,0,0,0,44.69.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M120.18,470.61c-2.26,2.26-5.41,0-8.1,1.06-6.14,2.39-12.41,1.92-23.79-5.62-.52,4.66,1.26,9.21,3.33,12.95,6.85,12.33,17.75,20.18,29,20.87"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M123.39,470.13c-1.72,4.7-6.56,4.69-9.35,8.29-6.38,8.21-14.21,13.07-31.46,13.74,1.47,6.11,5.7,10.11,9.92,12.85a40.48,40.48,0,0,0,44.68.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M116.62,308.94c2.73.79,4.94-3,7.7-3.6,6.31-1.29,11.9-5.25,20.06-18.56,1.85,4,1.57,9.12.78,13.7-2.6,15.12-10.23,28.44-20.28,35.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M113.54,310.31c3,3.32,7.38.59,11,2.29,8.25,3.9,16.84,3.91,32.78-5.21.47,6.41-2.21,12.44-5.25,17.33-10,16.12-25.32,25.7-40.7,25.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M134.45,369.86c2.73.79,4.94-3,7.7-3.6,6.31-1.29,11.9-5.25,20.06-18.56,1.85,3.95,1.57,9.12.78,13.7-2.6,15.12-10.23,28.43-20.28,35.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M131.37,371.23c3,3.32,7.38.59,11,2.29,8.25,3.89,16.84,3.91,32.78-5.21.47,6.41-2.21,12.44-5.25,17.33-10,16.12-25.32,25.7-40.7,25.48"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M151.37,466.18c2.73.79,4.94-3,7.7-3.59,6.31-1.29,11.9-5.26,20.06-18.56,1.85,4,1.57,9.11.78,13.69-2.6,15.12-10.23,28.44-20.28,35.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M148.29,467.56c3,3.32,7.38.58,11,2.28,8.25,3.9,16.84,3.91,32.78-5.2.47,6.41-2.21,12.44-5.25,17.32-10,16.12-25.32,25.71-40.7,25.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M147.2,336c-18.16,26.49-44.48,32.35-67,31.3-3-35.14-4.69-76,2.83-110.15,2.66-12.11,6.53-32,15.45-29.13,4.49,1.47,10.25,12.63,12.88,17.86A588.55,588.55,0,0,1,147.2,336Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M166.84,418.14v0c-21.72,25.7-52.31,27.21-75.15,23.52-3-13.76-5.6-27.68-7.67-41.77-1.58-10.84-2.88-21.71-3.79-32.58,22.5,1.05,48.82-4.81,67-31.3A664.35,664.35,0,0,1,166.84,418.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M175.39,567.16l-59.25-34.43c-9-29.88-17.73-60.09-24.46-91.05,22.84,3.69,53.43,2.18,75.15-23.52C175.35,467.27,178.53,517.9,175.39,567.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M152.83,555.21a.8.8,0,0,1-.78-.65L96.28,249.46a.8.8,0,0,1,1.57-.29l55.77,305.1a.8.8,0,0,1-.64.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M114.74,346.68h-.06A65.37,65.37,0,0,1,84.84,335.6a.8.8,0,1,1,.92-1.3,63.77,63.77,0,0,0,29,10.8.78.78,0,0,1,.74.84A.8.8,0,0,1,114.74,346.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M116.83,355a.79.79,0,0,1-.72-.46.8.8,0,0,1,.39-1.06,58.73,58.73,0,0,0,19.16-15.78.8.8,0,1,1,1.26,1,59.32,59.32,0,0,1-19.76,16.25A.75.75,0,0,1,116.83,355Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M125.38,399.91a.8.8,0,0,1-.37-1.51,60.58,60.58,0,0,0,18.79-16.65.79.79,0,0,1,1.11-.18.8.8,0,0,1,.17,1.11,61.06,61.06,0,0,1-19.34,17.14A.8.8,0,0,1,125.38,399.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M138.5,472a.76.76,0,0,1-.63-.31.79.79,0,0,1,.14-1.11,70.47,70.47,0,0,0,16.76-20.46.79.79,0,1,1,1.4.75,72.29,72.29,0,0,1-17.19,21A.77.77,0,0,1,138.5,472Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M138.8,484.66h-.06a65.33,65.33,0,0,1-29.85-11.09.79.79,0,1,1,.92-1.29,63.5,63.5,0,0,0,29,10.79.8.8,0,0,1,0,1.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M128.9,425h-.05a62.33,62.33,0,0,1-17.34-4.33.8.8,0,0,1,.59-1.48A61.86,61.86,0,0,0,129,423.36a.8.8,0,0,1,0,1.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M106.13,300.35h0A62.65,62.65,0,0,1,88.75,296a.8.8,0,1,1,.59-1.48,62.29,62.29,0,0,0,16.84,4.22.81.81,0,0,1,.75.85A.8.8,0,0,1,106.13,300.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M121,381.87h-.06a62.3,62.3,0,0,1-17.33-4.33.8.8,0,0,1,.59-1.48A61.78,61.78,0,0,0,121,380.28a.8.8,0,0,1-.05,1.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M110.79,321.92a.79.79,0,0,1-.41-1.47,73.19,73.19,0,0,0,9-6.75.78.78,0,0,1,1.12.08.79.79,0,0,1-.08,1.12,72.14,72.14,0,0,1-9.19,6.91A.77.77,0,0,1,110.79,321.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M145.2,510.42a.81.81,0,0,1-.69-.39.8.8,0,0,1,.28-1.09,74.11,74.11,0,0,0,9-6.75.78.78,0,0,1,1.12.08.79.79,0,0,1-.08,1.12,71.76,71.76,0,0,1-9.2,6.91A.72.72,0,0,1,145.2,510.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M166.06,516.7c1.92,7.2,3.43,14.54,3.14,22-.31,8.13-2.69,16-5.5,23.57-.53,1.44,1.77,2.06,2.3.63,2.89-7.78,5.27-15.85,5.59-24.2.3-7.68-1.26-15.26-3.22-22.65a1.2,1.2,0,0,0-2.31.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M87.91,271.57c.73-5.55,1.79-11.29,2.93-16.86a2.39,2.39,0,1,0-4.6-1.27c-1.23,6-2.3,12.05-3.1,18.13A2.4,2.4,0,0,0,85.53,274a2.45,2.45,0,0,0,2.38-2.39Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-21",
    cx: 90.35,
    cy: 245.48,
    rx: 3.01,
    ry: 1.7,
    transform: "translate(-167.49 289.5) rotate(-79.48)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M30.64,392.67c-1.44,2.39-5,2.13-7.15,3.87-5,4-10.88,6.13-23.49,5.54.83,3.31,3.76,5.65,6.73,7.33A39.22,39.22,0,0,0,39.31,412"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M33.47,391.09c-.26,3.81-4.71,5.7-6.27,9.18-3.55,8-9.39,14.26-25.08,21.45,3.09,3.5,8.11,4.51,12.77,4.69a53.65,53.65,0,0,0,41.22-17.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M105.56,508.37c-1.44,2.39-5,2.12-7.15,3.86-5,4-10.88,6.13-23.49,5.55.83,3.31,3.76,5.65,6.73,7.33a39.3,39.3,0,0,0,32.58,2.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M108.39,506.79c-.26,3.8-4.71,5.69-6.27,9.17-3.55,8-9.39,14.26-25.08,21.45,3.09,3.5,8.11,4.51,12.77,4.69A53.67,53.67,0,0,0,131,524.85"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M56.58,402c2.74-.54,3.69-3.95,6.07-5.4,5.45-3.33,9.47-8.15,13.21-20.2,2.83,1.91,4,5.45,4.6,8.82a39.28,39.28,0,0,1-8.66,31.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M54.13,404.12c3.67,1.06,7-2.49,10.77-2.77,8.7-.62,16.6-4,28.7-16.27,2.24,4.09,1.48,9.16.07,13.6A53.73,53.73,0,0,1,63.4,431.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M90.22,435.64c2.74-.54,3.69-3.95,6.07-5.41,5.45-3.32,9.47-8.14,13.21-20.2,2.83,1.91,4,5.46,4.6,8.83a39.28,39.28,0,0,1-8.66,31.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M87.77,437.76c3.67,1.05,7-2.49,10.76-2.77,8.7-.63,16.61-4,28.71-16.27,2.24,4.09,1.48,9.15.06,13.6A53.69,53.69,0,0,1,97,465.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M133,493.23c2.74-.54,3.69-4,6.07-5.4,5.45-3.33,9.47-8.15,13.21-20.2,2.83,1.9,4,5.45,4.6,8.82A39.28,39.28,0,0,1,148.25,508"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M130.58,495.35c3.67,1.06,7-2.49,10.76-2.77,8.7-.63,16.61-4,28.71-16.27,2.24,4.09,1.48,9.16.07,13.6a53.73,53.73,0,0,1-30.27,32.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M92.39,408.11c-9.23,24.75-31.8,38.94-52.81,47-12.67-22.26-25.8-48.8-28.54-74.51-1-9.11-3-23.9,6-25.45,4.54-.78,13,4.41,16.9,6.87A367.65,367.65,0,0,1,92.39,408.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M133.68,455.17h0c-12.72,25.62-40.46,38.57-62.53,45-6.65-8-13-16.26-18.87-24.84-4.52-6.61-8.79-13.35-12.7-20.24,21-8.08,43.58-22.27,52.81-47A374.8,374.8,0,0,1,133.68,455.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M183.69,551.16l-64.28.18C102.67,535,86.1,518.22,71.15,500.21c22.07-6.46,49.81-19.41,62.53-45C155.41,484.59,172.66,517.09,183.69,551.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M159.33,552.14a.67.67,0,0,1-.54-.26L21.18,370.31a.68.68,0,1,1,1.08-.82l137.6,181.57a.67.67,0,0,1-.13,1A.66.66,0,0,1,159.33,552.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M39.55,432.4c-1.49,0-3,0-4.51-.16a.67.67,0,0,1-.62-.72.67.67,0,0,1,.72-.63c15.35,1.13,29.77-4.11,29.92-4.16a.68.68,0,0,1,.47,1.27A85,85,0,0,1,39.55,432.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M69.57,432.77a.69.69,0,0,1-.51-.23.68.68,0,0,1,.06-1,60,60,0,0,0,13.22-18,.67.67,0,0,1,1.23.55C78.8,424.76,70.1,432.52,70,432.6A.7.7,0,0,1,69.57,432.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M90.13,459.36a.67.67,0,0,1-.49-.21.68.68,0,0,1,0-1,60.26,60.26,0,0,0,12.61-18.47.68.68,0,0,1,1.26.51A61.77,61.77,0,0,1,90.6,459.17.66.66,0,0,1,90.13,459.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M122.59,502.28a.7.7,0,0,1-.41-.14.67.67,0,0,1-.12-.95A60.37,60.37,0,0,0,131.71,481a.66.66,0,0,1,.81-.5.67.67,0,0,1,.5.81,61.65,61.65,0,0,1-9.89,20.7A.67.67,0,0,1,122.59,502.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M100.71,515c-1.49,0-3-.05-4.51-.16a.67.67,0,0,1-.62-.73.65.65,0,0,1,.72-.62c15.34,1.13,29.77-4.11,29.92-4.17a.68.68,0,0,1,.87.41.66.66,0,0,1-.4.86A84.84,84.84,0,0,1,100.71,515Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M83.52,478.5a.68.68,0,0,1-.08-1.35,82.76,82.76,0,0,0,16.78-3.79.68.68,0,0,1,.47,1.27,83.55,83.55,0,0,1-17.09,3.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M27.33,404.34a.67.67,0,0,1-.67-.59.68.68,0,0,1,.59-.76A83.18,83.18,0,0,0,44,399.21a.68.68,0,1,1,.47,1.27,85.15,85.15,0,0,1-17.09,3.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M64,452.89a.68.68,0,0,1-.08-1.35,82.76,82.76,0,0,0,16.79-3.79A.68.68,0,1,1,81.2,449a83.54,83.54,0,0,1-17.1,3.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M54.66,413.08a.66.66,0,0,1-.47-.19.67.67,0,0,1,0-.95,77.07,77.07,0,0,0,6.36-8,.67.67,0,0,1,.94-.16.67.67,0,0,1,.17.94,76.09,76.09,0,0,1-6.49,8.18A.68.68,0,0,1,54.66,413.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M139.63,525.27a.66.66,0,0,1-.47-.19.68.68,0,0,1,0-1,75.13,75.13,0,0,0,6.37-8,.68.68,0,0,1,1.11.77,77.61,77.61,0,0,1-6.49,8.18A.7.7,0,0,1,139.63,525.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M161.09,521.22c3.68,3.93,7.2,8.2,9,13.33,2,5.66,2,11.76,1.57,17.68-.1,1.31,1.94,1.3,2,0,.44-6.17.44-12.6-1.74-18.49-2-5.36-5.58-9.82-9.45-14-.9-1-2.33.48-1.44,1.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M19.35,388.7c-.47-2.08-.87-4.18-1.22-6.29s-.65-4.15-.88-6a2.08,2.08,0,0,0-2-2c-1,0-2.18.9-2,2,.56,4.49,1.25,9,2.24,13.38a2,2,0,0,0,2.5,1.42,2.08,2.08,0,0,0,1.42-2.5Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-21",
    cx: 14.45,
    cy: 369.96,
    rx: 1.66,
    ry: 2.23
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M537.64,468.89c-2,9.37-21.46,28.66-27.63,36.05-9.42,11.27-18.87,20-32.23,26.08a158.55,158.55,0,0,1-125.27,2.91c-38.74-15.67-70.22-49.33-81.36-89.61a145.13,145.13,0,0,1-5-39.46,163.22,163.22,0,0,1,1.79-23.26c2.63,11.87,5.73,23.59,10.53,34.75a125.87,125.87,0,0,0,80.26,70.41c11.32,3.2,23.05,4.77,34.78,5.75C436.9,496.11,495.85,481.16,537.64,468.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M402.56,42.51a36.42,36.42,0,0,0-38.69,8.64C355,60.55,351.82,74.09,351.31,87s1.21,25.92.33,38.85c-1.12,16.55-6.5,32.92-4.75,49.41,1.19,11.3,5.67,22,7.94,33.11a86.17,86.17,0,0,1,.26,33.07c-2,10.4-5.82,21.24-2.34,31.24,2.44,7,8.25,12.41,14.8,15.88s13.85,5.2,21.09,6.81,15.27,3.15,22.36.5c7.77-2.91,13-10.25,16.79-17.62a109.16,109.16,0,0,0,8.65-22.36c1.65-6.24,2.76-12.69,5.56-18.51,2.11-4.39,5.12-8.29,7.64-12.47,14.41-23.82,11.94-54.19,4.81-81.1S436,90.82,434,63.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M426.91,200.8a59.67,59.67,0,0,0,18.23-42.9c3.33,0,6.23,2.17,8.74,4.36s5.07,4.59,8.33,5.29,7.32-1.23,7.5-4.55c-.59,6-1,12.73,2.88,17.37,2.59,3.11,6.63,4.65,9.56,7.44,3.26,3.11,4.91,7.53,6.16,11.86,3.72,12.93,4.76,27,.28,39.71s-15.17,23.63-28.41,26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M659.81,345a10.12,10.12,0,0,1-.78-12.44L659,333c3.87-6.56,11.77-9.35,19-11.65l13.15-4.17A17.54,17.54,0,0,1,696.9,316c3.25.11,6.13,2,8.83,3.79,8.18,5.5,16.56,11.19,22,19.37a2.64,2.64,0,0,1,.62,2.11c-.42,1.35-2.37,1.19-3.69.71a81.91,81.91,0,0,1-14.07-6.66c-3.59-2.14-7.7-4.66-11.66-3.32-3.22,1.09-5.08,4.36-6.9,7.24s-4.4,5.88-7.81,5.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M632.29,349.65c5.46-6.69,15-9.23,23.46-7.58s15.88,7,21.46,13.58c-3.37,3-8.34,3.21-12.86,3.22l-36.93.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M571.67,364.55A57.11,57.11,0,0,1,567,339c10.08,3.29,21,1.73,31.49.14l22.64-3.45c11.77-1.79,24.84-3.3,34.65,3.45a40.78,40.78,0,0,0-15.22,4.62,20,20,0,0,1,8.85,8.33,3.71,3.71,0,0,1,.62,2.69c-.37,1.41-2,2-3.47,2.28a138,138,0,0,1-37.81,3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M617,656.37c2.44,10-3.39,20.74-.45,30.59,2.54,8.51,11,13.95,19.5,16.69,9.7,3.15,20,3.76,30.24,3.84,19.05.16,39.5-2,54.07-14.2,1.69-1.42,3.37-3.1,3.81-5.26,1-4.71-4.08-8.28-8.45-10.34a270.31,270.31,0,0,0-38-14.48c-5.1-1.51-10.26-2.88-15.06-5.16-3.5-1.67-6.83-3.83-10.62-4.65s-8.33.07-10.38,3.35c-3.32,5.33,1.72,13.17-1.91,18.3a9.63,9.63,0,0,1-5.59,3.41c-5.91,1.54-10.09-1.76-14.57-5.89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M615.78,665.64a16.21,16.21,0,0,0,8.67,11.77,15.07,15.07,0,0,0,14.22-.68,7,7,0,0,0,3.57-4.5c.31-1.9-.58-3.75-1.11-5.59a15.65,15.65,0,0,1,.33-9.71c-2.13-2.26-5.27-3-8.16-4s-6-2.49-7.16-5.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M496.39,383l1.38,11.89-50.31,11.36c23.75-10.86,50.52-12.91,76.64-13.28,13.3-.19,26.84,0,39.5,4.11,12.1,3.88,23.45,11.76,29,23.12l.15.6,6.9,32.88q6.87,32.84,13.76,65.68c9.46,45.17,19,90.47,22.79,136.46h0a37.71,37.71,0,0,1-18.69,10.54l-1.59.37q-44.76-91.41-86.41-184.28l15.28-4.48A703.32,703.32,0,0,1,416.9,497.56c-8.7.53-17.53.88-26-1-23.94-5.17-41.9-28.35-43.69-52.78s11.16-48.7,30.79-63.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M425.6,222.63a66.18,66.18,0,0,0-14.18-11.43c-5.63-3.38-12.59-5.93-18.65-3.43-5.55,2.3-8.73,8.22-10.27,14a44.92,44.92,0,0,0,3.33,31.48c4.93,9.71,13.2,17.24,21.44,24.36q29,25.11,60.39,47.34a75.36,75.36,0,0,0,10.72,6.7c4.38,2.12,9.68,4.91,14.37,6.2,18.47,5.09,36,12.84,54.48,17.92,7.78,2.15,16.08,5.09,23.82,2.79,2.22-4.45,2.79-13.83,5-18.27-29.94-14.42-64.57-22.72-89.15-45.09-6.28-5.72-11.57-12.42-16.83-19.09-17.29-21.91-33.57-39.81-50.85-61.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M397.12,257.41a32.41,32.41,0,0,1,5.33,13.47,1.52,1.52,0,0,0,1.85,1.05,1.54,1.54,0,0,0,1-1.85,34.36,34.36,0,0,0-5.63-14.19,1.5,1.5,0,1,0-2.59,1.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M446.82,47.54l16-3.35c5.12-1.07,10.54-2.13,15.5-.47-2.07-3.3-5.68-5.28-9.26-6.82a71.1,71.1,0,0,0-24.62-5.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M414.05,212.18l34.69,43.25c5.54,6.9,11,13.82,16.62,20.69,5,6.12,10.06,12.16,15.61,17.77a101.43,101.43,0,0,0,20.6,16.37.75.75,0,0,0,.75-1.29c-13.7-8-24.46-19.92-34.42-32.09-11.24-13.73-22.23-27.66-33.33-41.5l-19.46-24.27c-.6-.75-1.66.32-1.06,1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M417.21,288.83c21.87,15.44,41.79,34.43,66.49,45.44A96.5,96.5,0,0,0,504.6,341c.94.19,1.35-1.26.4-1.44-26.44-5.16-48-22.34-68.84-38.4-6-4.63-12-9.23-18.19-13.6-.79-.56-1.54.74-.76,1.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M398.55,421.9c15.08,3.64,31.68-2.19,41.79-13.81A40.19,40.19,0,0,0,447.2,397c.73-1.78-2.17-2.56-2.9-.8-5.41,13.15-18.91,22.34-32.93,23.65a36.55,36.55,0,0,1-12-.83c-1.88-.45-2.68,2.44-.8,2.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M502.77,392.37l-39.83,5.79c-1.91.27-1.1,3.17.8,2.89l39.83-5.79c1.9-.28,1.09-3.17-.8-2.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M197.3,279.26c5.32,5.26,3.1,13.36,1.14,19.58-2.34,7.42-3.48,14.83-2.45,22.59.12.95,1.63,1,1.5,0a46,46,0,0,1,0-12.52,79.48,79.48,0,0,1,3.06-11.84c1.85-6.2,2.88-13.85-2.2-18.87-.69-.68-1.75.38-1.06,1.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M530.08,483.9l17-5.29c1.83-.57,1-3.47-.8-2.9L529.28,481c-1.84.57-1.06,3.46.8,2.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M542.11,490.54a1,1,0,0,1-.91-.59l-1.46-3.18a1,1,0,1,1,1.82-.83l1.45,3.18a1,1,0,0,1-.9,1.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M612.26,644.16a1,1,0,0,1-.91-.59l-2.92-6.4a1,1,0,0,1,1.82-.83l2.92,6.4a1,1,0,0,1-.49,1.33A1.06,1.06,0,0,1,612.26,644.16Zm-5.84-12.81a1,1,0,0,1-.91-.58l-2.93-6.4a1,1,0,1,1,1.82-.83l2.92,6.4a1,1,0,0,1-.49,1.32A.87.87,0,0,1,606.42,631.35Zm-5.85-12.8a1,1,0,0,1-.91-.58l-2.92-6.4a1,1,0,0,1,.49-1.33,1,1,0,0,1,1.32.5l2.93,6.4a1,1,0,0,1-.5,1.32A1,1,0,0,1,600.57,618.55Zm-5.85-12.8a1,1,0,0,1-.91-.58l-2.92-6.4a1,1,0,1,1,1.82-.83l2.92,6.4a1,1,0,0,1-.49,1.32A1.06,1.06,0,0,1,594.72,605.75ZM588.88,593a1,1,0,0,1-.91-.58L585,586a1,1,0,0,1,1.82-.83l2.93,6.4a1,1,0,0,1-.5,1.33A1,1,0,0,1,588.88,593ZM583,580.15a1,1,0,0,1-.91-.59l-2.92-6.4a1,1,0,0,1,1.82-.83l2.92,6.4a1,1,0,0,1-.5,1.33A1,1,0,0,1,583,580.15Zm-5.85-12.8a1,1,0,0,1-.91-.59l-2.92-6.4a1,1,0,0,1,1.82-.83l2.92,6.4a1,1,0,0,1-.49,1.33A1.06,1.06,0,0,1,577.18,567.35Zm-5.84-12.8a1,1,0,0,1-.91-.59l-2.93-6.4a1,1,0,0,1,.5-1.33,1,1,0,0,1,1.32.5l2.93,6.4a1,1,0,0,1-.5,1.32A.86.86,0,0,1,571.34,554.55Zm-5.85-12.81a1,1,0,0,1-.91-.58l-2.92-6.4a1,1,0,1,1,1.82-.83l2.92,6.4a1,1,0,0,1-.49,1.32A1.06,1.06,0,0,1,565.49,541.74Zm-5.85-12.8a1,1,0,0,1-.91-.58l-2.92-6.4a1,1,0,0,1,1.82-.84l2.92,6.41a1,1,0,0,1-.49,1.32A1.06,1.06,0,0,1,559.64,528.94Zm-5.84-12.8a1,1,0,0,1-.91-.58L550,509.15a1,1,0,1,1,1.81-.83l2.93,6.4a1,1,0,0,1-.5,1.33A1,1,0,0,1,553.8,516.14ZM548,503.34a1,1,0,0,1-.91-.59l-2.92-6.4a1,1,0,0,1,1.82-.83l2.92,6.4a1,1,0,0,1-.49,1.33A1.06,1.06,0,0,1,548,503.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M616.64,653.74a1,1,0,0,1-.91-.58L614.28,650a1,1,0,0,1,1.81-.83l1.46,3.19a1,1,0,0,1-.5,1.32A1,1,0,0,1,616.64,653.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M96.86,549.84h145a1.65,1.65,0,0,1,1.64,1.95L217.21,700.37a1.66,1.66,0,0,1-1.64,1.37h-92.4a1.67,1.67,0,0,1-1.64-1.37L95.22,551.79A1.66,1.66,0,0,1,96.86,549.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M529.92,241.73a263.62,263.62,0,0,1,.73,78.72h0l-1.11,7.83-15.06,38-127.72,3.95,3.59-7.58c9.08-19.24,20.25-40.72,17.13-61.76l-13.5-91a5.2,5.2,0,0,1,1.11-4.07,47,47,0,0,1,34.64-17.27l1.51-.05a5.19,5.19,0,0,1,3.68,1.31l40.88,36.43L486,194.06a3.76,3.76,0,0,1,6-1.76L512,209l6.1,5.07,0,0,.11.11a38.48,38.48,0,0,1,10.64,21.2Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 156.6,
    y: 359.02,
    width: 748.53,
    height: 33.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 156.6,
    y: 375.79,
    width: 748.53,
    height: 16.77
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M418.12,214l34.69,43.25c5.53,6.9,11,13.83,16.62,20.7,5,6.12,10.06,12.16,15.61,17.76a101.14,101.14,0,0,0,20.6,16.38.75.75,0,0,0,.75-1.3c-13.7-8-24.46-19.92-34.42-32.08-11.24-13.73-22.23-27.67-33.33-41.51L419.18,212.9c-.6-.75-1.66.31-1.06,1.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M421.28,290.62c21.87,15.44,41.79,34.42,66.49,45.43a97.08,97.08,0,0,0,20.9,6.72c.94.18,1.34-1.26.4-1.45-26.44-5.16-48-22.34-68.84-38.39-6-4.63-12-9.24-18.19-13.6-.79-.56-1.54.74-.76,1.29Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 820.27,
    y: 81.98,
    width: 6.78,
    height: 29.36,
    transform: "translate(1294.11 -586.3) rotate(117.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 816.89,
    y: 101.74,
    width: 6.78,
    height: 29.36,
    transform: "translate(981.97 -696.14) rotate(93.18)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 819.99,
    y: 121.51,
    width: 6.78,
    height: 29.36,
    transform: "translate(912.76 965.96) rotate(-105.54)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M189.4,692.08h-69a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h69a.5.5,0,0,1,.5.5A.5.5,0,0,1,189.4,692.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M183.19,684.86H119.1a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h64.09a.5.5,0,0,1,.5.5A.5.5,0,0,1,183.19,684.86Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 192.6,
    y: 320.85,
    width: 10.45,
    height: 15.81
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M472.44,180c-13.46-5.83-22-13.78-27.2-20.38,0-.09,0-.17,0-.26,3.34,2.45,6.73,4.71,10.08,6.74,2.58,1.58,5.35,3.1,8.38,3.24a11.49,11.49,0,0,0,5.26-1.1l.36.24c-.09,4.19.51,8.3,3.07,11.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M469.57,23.62a30.44,30.44,0,0,1,27,.36c-5.9.15-12,1.57-16.57,5.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M413.14,113.52c.87,22.78,22.49,41.73,42.15,53.26,2.62,1.53,5.41,3,8.44,3.1,4.65.13,8.71-3,12.1-6.21,14.41-13.54,21.31-31.21,24.93-50.65s-.5-40.58-12.76-56.09c-5.26-6.66-12.13-12.33-20.28-14.67-5.65-1.63-11.64-1.6-17.51-1.14A127.71,127.71,0,0,0,428,44.83c-5.8,1.51-11.63,3.5-16.22,7.35S404,62.07,405.08,68s7.21,10.83,13,9.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M475.1,131.69c1.6-.05,3.69-.24,5-1.32,1.6-1.34.43-3.09-.33-4.53a30.26,30.26,0,0,1-3.3-11.61c-.08-1-1.61-1-1.53,0a31.8,31.8,0,0,0,2.31,9.79c.31.74.64,1.48,1,2.2a7.32,7.32,0,0,1,1.13,2.36c.06,1.42-3.35,1.55-4.25,1.58a.77.77,0,0,0,0,1.53Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-30",
    cx: 464.1,
    cy: 107.85,
    rx: 6.52,
    ry: 4.58,
    transform: "translate(349.58 570.34) rotate(-89.17)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-30",
    cx: 487.01,
    cy: 108.18,
    rx: 6.52,
    ry: 4.58,
    transform: "translate(371.82 593.57) rotate(-89.17)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M503.71,100.11a21.14,21.14,0,0,0-20.63-6l-.55-2.17a23.32,23.32,0,0,1,22.82,6.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M447.39,98.75l-1.56-1.62A23.89,23.89,0,0,1,453.94,92a23.49,23.49,0,0,1,15-.46l-.65,2.15a21.11,21.11,0,0,0-20.9,5.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M488.93,104.12a5.42,5.42,0,0,0,4.29,0,7.63,7.63,0,0,0,2.47-1.53,1.73,1.73,0,0,1-.37,1.2,11.18,11.18,0,0,1-5.86,4.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M486.53,103.33a5.4,5.4,0,0,0,4.11-1.21,7.85,7.85,0,0,0,1.93-2.17,1.66,1.66,0,0,1,0,1.24,11.15,11.15,0,0,1-4.32,6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M461,103.33a5.46,5.46,0,0,1-4.27-.41,7.66,7.66,0,0,1-2.31-1.77,1.75,1.75,0,0,0,.25,1.23,11.18,11.18,0,0,0,5.39,5.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M463.49,102.78a5.47,5.47,0,0,1-4-1.61,7.77,7.77,0,0,1-1.7-2.36,1.7,1.7,0,0,0-.12,1.24,11.15,11.15,0,0,0,3.71,6.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M485,135.64c.07,6.28-5.41,12.7-12.08,12.77s-12-6.22-12.09-12.5c0-.15,0-.31,0-.46a27,27,0,0,0,24.15-.27C485,135.33,485,135.49,485,135.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M495.2,77.4a2.49,2.49,0,0,1-.53-.07c-5.8-1.6-9-6.9-10.38-9.92a2,2,0,0,1,3.64-1.67c1.86,4.06,4.7,6.88,7.8,7.73a2,2,0,0,1-.53,3.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M418.3,92.92a2,2,0,0,1-.29-4l4.71-.69c10.28-1.57,22.22-4,32.7-10,9.6-5.48,17.2-15.69,20.34-27.3a2,2,0,0,1,3.86,1c-3.41,12.62-11.71,23.73-22.21,29.74-11.06,6.32-23.44,8.84-34.1,10.47l-4.72.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M397.73,92.44c16.44-.82,43-3.69,57-12.43,12.61-7.92,18.5-18.43,22.5-28.81s-8.13-27.69-17.32-34c-3.86-2.64-8.54-3.84-13.18-4.42C423.2,9.9,398.53,23.37,388.28,44.74"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 412.38,
    cy: 110.67,
    rx: 13.31,
    ry: 15.44
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M408.16,116.91a.49.49,0,0,1-.47-.34A13,13,0,0,1,410.21,104a.5.5,0,0,1,.7,0,.49.49,0,0,1,0,.7,12,12,0,0,0-2.33,11.6.49.49,0,0,1-.31.63A.45.45,0,0,1,408.16,116.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M412.56,112.41a.52.52,0,0,1-.33-.12c-1.4-1.18-3.09-1.91-4.07-1.78a.5.5,0,0,1-.56-.43.49.49,0,0,1,.43-.56c1.58-.22,3.59,1,4.85,2a.51.51,0,0,1,.06.71A.49.49,0,0,1,412.56,112.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M483.85,64A2,2,0,0,1,482,62.71l-.49-1.3a31.62,31.62,0,0,0-3.88-7.28,2,2,0,1,1,3.26-2.32A35.58,35.58,0,0,1,485.23,60l.49,1.3a2,2,0,0,1-1.87,2.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M469.26,42.92a36.75,36.75,0,0,1,12.31,13.57c2.23,4.25,3.62,8.94,6.3,12.93s7.18,7.28,11.93,6.63c6.45-.87,9.88-8.3,10.13-14.8.45-11.39-5.38-22.58-14.26-29.74S475.18,21,463.78,21.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M461.79,23.07a30.45,30.45,0,0,1,26.46-5.37c-5.73,1.4-11.36,4.07-15.08,8.66"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 884.29,
    y: 83.2,
    width: 1,
    height: 258.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 878.4,
    y: 83.2,
    width: 1,
    height: 258.13
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWomanWorking2);
export default __webpack_public_path__ + "static/media/woman_working_2.26b4fe242bd386b51ed8fe80be6ff7bb.svg";
export { ForwardRef as ReactComponent };